<template>
    <div v-if="loading == false">
        <ChirpList
            :data_source="rows"
            :export_api="export_api"
            :totalCount="totalCount"
            :target_page="targetPage"
            @applyCriteria="modifyCriteria"
            :loadingColumns="loadingTable"
            :column_meta="columnMeta"
            :storeKey="storeKey"
            :useOverride="useOverride"
            @cancelOverride="handleCancelOverride"
        />
    </div>
    <div v-else>Loading...</div>
</template>

<script>
    import { tryGetFilter } from '@/util/tryGetFilter';

    const api_root = 'payments/list';

    import ChirpList from '@/components/general/list/ChirpList';

    export default {
        name: 'Payments',
        components: { ChirpList },
        props: {
            overrideFilter: {
                type: Object,
                default: null
            }
        },
        data() {
            return {
                rows: [],
                totalCount: 0,
                useOverride: false,
                targetPage: 'PaymentDetail',
                loading: true,
                loadingTable: false,
                criteriaProps: {},
                export_api: '/payments/list',
                columnMeta: [
                    { field: 'date', headerText: 'Date' },
                    { field: 'payment_type', headerText: 'Payment Type' },
                    { field: 'client', headerText: 'Client' },
                    { field: 'checknum', headerText: 'Check #' },
                    { field: 'comment', headerText: 'Comment', width: 220 },
                    { field: 'payment_amount', headerText: 'Amount' }
                    // { field: 'first_name', headerText: 'First Name', hide: 1 },
                    // { field: 'last_name', headerText: 'Last Name', hide: 1 }
                ]
            };
        },
        computed: {
            criteria() {
                return this.useOverride && this.overrideFilter ? this.overrideCriteria : this.savedCriteria;
            },
            savedCriteria() {
                return tryGetFilter(this.$store, this.storeKey);
            },
            overrideCriteria() {
                return this.$store.getters['filters/overrideCriteria'](this.storeKey);
            },
            storeKey() {
                return this.pageMeta?.page || 'payments';
            }
        },
        methods: {
            async load_data() {
                try {
                    const body = {
                        criteria: this.criteria
                    };
                    const res = await this.$api.post(this.export_api, body);

                    if (res.status >= 400) {
                        this.$toasted.error('Failed to fetch payments roster.');
                        return;
                    }

                    this.rows = res.data.rows;

                    this.totalCount = res.data.total_count;
                } catch (err) {
                    this.$toasted.error('Failed to fetch payments roster.');
                }
                this.$nextTick(() => {
                    this.loading = false;
                });
            },
            async init() {
                if (this.overrideFilter) {
                    this.useOverride = true;
                    this.$store.commit('filters/applyOverride', {
                        stateKey: this.storeKey,
                        criteria: this.overrideFilter
                    });
                }

                if (!this.criteria.sort || (this.criteria.sort && Object.keys(this.criteria.sort).length === 0)) {
                    this.$store.commit('filters/applyDefaultDateSort', { stateKey: this.storeKey });
                }

                await this.load_data();
            },
            async modifyCriteria(criteria) {
                if (this.targetPage) {
                    this.$store.commit('filters/update', {
                        criteriaPage: this.targetPage,
                        payload: criteria
                    });
                }
                this.criteriaProps = criteria;
                this.load_data();
            },
            handleCancelOverride() {
                this.useOverride = false;
            },
        },
        async created() {
            await this.init();
        },
        watch: {
            criteria: {
                deep: true,
                async handler() {
                    await this.load_data();
                }
            }
        }
    };
</script>
